import React from "react";
import PropTypes from "prop-types";
import { Icon, LoadingContainer, StyledButton, Content } from "./style";
import { colors } from "../../../theme/constants";
import ButtonLoader from "../../Loaders/ButtonLoader";
import RippleButton from "../RippleButton";
import SvgMask from "../../SvgMask";

const DefaultButton = (props) => {
    return (
        <RippleButton
            component={StyledButton}
            {...props}
            onClick={
                !props.loading || props.disabled ? props.onClick : () => {}
            }
        >
            {!!props.loading && (
                <LoadingContainer>
                    <ButtonLoader />
                </LoadingContainer>
            )}
            {props.icon && !props.loading ? (
                <Icon iconScale={props.iconScale} iconOnly={props.iconOnly}>
                    <SvgMask icon={props.icon} size={24} color={colors.WHITE} />
                </Icon>
            ) : null}
            {!props.iconOnly ? (
                <Content appearance={props.appearance}>
                    {props.children}
                </Content>
            ) : null}
        </RippleButton>
    );
};

DefaultButton.defaultProps = {
    iconScale: 1,
    iconOnly: false,
    disabled: false,
};

DefaultButton.propTypes = {
    children: PropTypes.any,
    icon: PropTypes.any,
    size: PropTypes.string,
    loading: PropTypes.bool,
    iconScale: PropTypes.number,
    iconOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    appearance: PropTypes.string,
};

export default DefaultButton;
